import React, { Component, MouseEvent } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { differenceBy, isEmpty, size, take } from 'lodash'
import routes from '../../routes/routes'
import { WorkOrderData } from '../../apis/workOrder.api'
import workOrderCalendar from '../../services/workOrderCalendar.service'
import { CalendarDate } from '../../views/WorkOrderCalendar/WorkOrderCalendar.slice'
import WorkOrder from './WorkOrder'
import WorkOrderCount from './WorkOrderCount'

interface Props extends RouteComponentProps {
  date: CalendarDate | null
}

class Date extends Component<Props> {
  dbClickId: ReturnType< typeof setTimeout> | null = null

  constructor (props: Props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  day (date: CalendarDate) {
    const className = () => {
      const isToday = workOrderCalendar.isDateToday(date.date)
      const base = 'flex justify-center items-center rounded-full w-6 h-6 font-medium'
      const today = isToday && 'bg-blue-500 text-white'
      return `${base} ${today}`
    }
    return (
      <div className={className()}>
        {date.day}
      </div>
    )
  }

  workOrders (workOrders: WorkOrderData[]) {
    return workOrders.map(workOrder => {
      return <WorkOrder workOrder={workOrder} key={workOrder.id} />
    })
  }

  trimCount (trimCount: number) {
    return Boolean(trimCount) && <WorkOrderCount count={trimCount} />
  }

  handleSingleClick (date: CalendarDate) {
    if (isEmpty(date.workOrders)) return
    const pathname = routes.workOrders
    const state = {
      produceAt: workOrderCalendar.getProduceAtDateOnly(date.date)
    }
    this.props.history.push({ pathname, state })
  }

  handleDoubleClick (date: CalendarDate) {
    const pathname = routes.workOrderCreate
    const state = {
      produceAt: workOrderCalendar.getProduceAtDateOnly(date.date)
    }
    this.props.history.push({ pathname, state })
  }

  handleClick (event: MouseEvent) {
    const { date } = this.props
    if (!date) return
    const { detail } = event
    if (this.dbClickId) clearTimeout(this.dbClickId)
    if (detail === 1) {
      this.dbClickId = setTimeout(() => {
        this.handleSingleClick(date)
      }, 200)
    } else if (detail === 2) {
      this.handleDoubleClick(date)
    }
  }

  render () {
    const { date } = this.props
    if (!date) return null
    const workOrders = take(date.workOrders, 3)
    const trimCount = size(differenceBy(date.workOrders, workOrders, 'id'))
    return (
      <div
        className="flex flex-col gap-1 calendar-date p-2 h-full"
        onClick={this.handleClick}>
        {this.day(date)}
        {this.workOrders(workOrders)}
        {this.trimCount(trimCount)}
      </div>
    )
  }
}

export default withRouter(Date)
